import React from 'react';

const PickScore = ({pick}) => {
  if (!pick.event.score) {
    return null;
  }
  return (
    <div className="pick-score">
      {pick.event.score.home} - {pick.event.score.away}
    </div>
  );
};

export default PickScore;
